// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"9eb78f64","658":"6588a4b0","727":"a98e0dc6","787":"96c5fc94"}[chunkId] + ".chunk.js";
};